module.exports = __webpack_public_path__ + "static/media/seriousSeverePain.57f9fe82.mp3";